import is from '@sindresorhus/is'
import destr from 'destr'
import { HttpResponse, http } from 'msw'
import { reserveList } from './db'
import { genId } from '@api-utils/genId'
import { delay } from '@/utils/datetime'

export const handlerAppsReserveList = [
  // 👉 Get Calendar reserve list
  http.get("/api/apps/reservelist", async ({ request }) => {
    const url = new URL(request.url)
    const queries = url.searchParams.getAll("calendars")
    const parsedResourceIds = destr(queries)
    const resourceIds = is.array(parsedResourceIds) ? parsedResourceIds : undefined

    await delay(1000)
    // Fetch the reserve list
    reserveList.filter((res) =>
      resourceIds?.includes(res.assignment.calendar),
    )
    console.log('reservelist (index.js)', reserveList)

    return HttpResponse.json(reserveList, { status: 200 })
  }),

  // 👉 Add Reserve List Item
  http.post("/api/apps/reservelist", async ({ request }) => {
    const reserveListItem = await request.json()
    // Generate a unique ID for the new reserve list item
    const newReserveListItem = {
      ...reserveListItem,
      id: String(genId(reserveList)),
    }

    // Push the new item to the reserve list
    reserveList.push(newReserveListItem)

    return HttpResponse.json(newReserveListItem, { status: 201 })
  }),

  // 👉 Update Reserve List Item
  http.put("/api/apps/reservelist/:reserveListId", async ({ request, params }) => {
    console.log('lubie kotki', request, params)

    const updatedReserveListItem = await request.json()
    const reserveListItemId = params.reserveListId // Keep ID as a string

    // Find the reserve list item by ID
    const currentReserveListItem = reserveList.find((rl) => rl.reserveListId === reserveListItemId)

    if (currentReserveListItem) {
      // Update the existing reserve list item
      Object.assign(currentReserveListItem, updatedReserveListItem)

      return HttpResponse.json(currentReserveListItem, { status: 200 })
    }

    return new HttpResponse("Reserve List Item Not Found", { status: 404 })
  }),

  // 👉 Delete Reserve List Item
  http.delete("/api/apps/reservelist/:reserveListId", ({ params }) => {
    const reserveListItemId = params.reserveListId // Keep ID as a string
    // Find the index of the reserve list item to delete
    const reserveListItemIndex = reserveList.findIndex((rl) => rl.reserveListId === reserveListItemId)

    if (reserveListItemIndex !== -1) {
      // Remove the item from the reserve list
      reserveList.splice(reserveListItemIndex, 1)

      return new HttpResponse(null, { status: 204 })
    }

    return new HttpResponse("Reserve List Item Not Found", { status: 404 })
  }),

]
